import styled, { css } from "styled-components/macro";
import hh from "assets/images/Logo Hospi Housing.webp";

const maxWidthMediaLeftColumn = 850;
const maxWidthMediaRightColumn = 640;

// SHARED //

export const GridWrapper = styled.div<{ gap?: string }>`
  display: grid;
  gap: ${(props) => props.gap || "0px"};

  & li {
    list-style-type: none;
  }
`;

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 11px;

  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    flex-direction: column;
    justify-content: flex-start;

    & h2 {
      margin-bottom: 4px;
    }
  }

  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: row;
    justify-content: space-between;
  }

  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

// MAIN COMPONENT //

export const MainWrapper = styled.div`
  position: relative;

  max-width: ${(props) => props.theme.sizes.maxWidthMainWindow};
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: ${(props) => props.theme.sizes.heightHeaderDesktop} auto 47px;
  color: ${(props) => props.theme.colors.text};

  #handle-close {
    position: absolute;
    top: 0.5em;
    right: 0.5em;
    cursor: pointer;
    border: none;
    outline: none;
    margin: 0;
    padding: 0;
    background: transparent;
    font-size: 1rem;
    font-weight: 700;
    color: ${(props) => props.theme.colors.text};
    transition: all 0.3s ease;

    &:hover {
      transform: scale(1.2);
    }
  }

  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: column;
  }

  @media (max-width: 768px) {
    margin: 0px auto 47px;
    max-width: ${(props) => props.theme.sizes.maxWidthContainer};
  }

  @media (max-width: 570px) {
    margin: 0px auto 47px;
    max-width: 100vw;
  }

  @media (max-width: 375px) {
    margin: 0px auto 47px;
    max-width: 100vw;
  }
`;

export const MainBody = styled.div`
  display: flex;
  margin: 1rem;
  overflow: hidden;
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: column;
    margin: 0;
  }
`;

// ROOM NAVIGATION COMPONENT //

export const NavigationButton = styled.button`
  border: 1px solid #032565; // Adjust this to match your theme
  background-color: white;
  border-radius: 6px;
  padding: 8px, 16px, 8px, 16px;
  margin-right: 16px;
  margin-bottom: 8px;
  margin-top: 8px;
  width: 132px;
  height: 40px;
  cursor: pointer;

  &:hover {
    background-color: #f2f2f2;
  }
`;

export const RoomNavigationSection = styled.div`
  display: flex;
  /* align-items: center; */
  flex-direction: column;
  margin: 0 16px;
  padding: 0 16px;
  /* display: flex;
  flex-wrap: wrap;
  margin: 1rem;
  font-size: ${(props) => props.theme.font.sizeTitle};
  font-weight: ${(props) => props.theme.font.weightBold};
  align-items: center;

  & .my-rooms {
    color: ${(props) => props.theme.colors.textDimmed};
    margin-right: 16px;
    cursor: pointer;
  }

  & .title-city-container {
    flex-grow: 1;
    width:25rem;

    @media (max-width: 570px) {
      width:20rem;
  }
  }

  @media (max-width: 450px) {
    margin-top: 24px;

    & .my-rooms {
      font-size: 18px;
    }

    & svg {
      transform: rotateY(180deg);
      margin-right: 4px;
      order: -1;
      display: block;
    }
  } */
`;

export const RoomInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RoomTitle = styled.span`
  font-size: 32px; // Adjust as needed
  display: flex;
  align-items: center;
  color: #333333;
  font-weight: 500;
  gap: 24px;
`;

export const CityName = styled.span`
  font-size: 24px; // Adjust as needed
  color: #333333;
  font-weight: 500;
`;

export const NavigationSpan = styled.span`
  margin-right: 5px !important;
`;

// LEFT COLUMN //

export const LeftColumnAbout = styled.div`
  display: flex;
  flex: 2;
  overflow: hidden;
  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    flex-direction: column;
  }
`;

export const DetailsSection = styled.div`
  min-width: 288px;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* background: ${(props) => props.theme.colors.place}; */
`;

// ROOM DETAILS COMPONENT //

export const RoomDetailsSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RoomDetailsSectionNew = styled.div`
  display: flex;
  flex-wrap: wrap; /* Allows child items to wrap to the next row */
  justify-content: space-between;
  margin: 10px;
  border: 1px solid #dfe1eb;
  border-radius: 4px;
  padding: 24px 46px 24px 24px;
  overflow: hidden;
  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    padding: 24px 8px;
  }
`;

export const HalfWidthDiv = styled.div`
  width: 48%;
  text-align: left;
  margin-bottom: 20px;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const CompleteWidthDiv = styled.div`
  width: 96%;
  text-align: left;
  margin-bottom: 20px;
  overflow-wrap: break-word;
  word-wrap: break-word;
`;

export const ImportantValuesStyle = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px;
  border: 1px solid #dfe1eb;
  border-radius: 4px;
  padding: 24px 46px 24px 24px;
  & > div {
    text-align: left;
    margin-bottom: 20px;
  }

  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    padding: 24px;
  }
`;

export const RoomDetailsDescription = styled.p`
  font-size: 16px;
  font-weight: 400;
  line-height: 20.8px;
  height: 100%;
  word-break: break-word;
`;

export const TypeOfRoom = styled.div`
  display: flex;
  flex-direction: column;
  margin: 8px 0;
`;

export const Location = styled.div`
  display: flex;

  & div {
    flex: 1;
  }

  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    flex-direction: column;
  }
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    flex-direction: row;
  }
  @media (max-width: 460px) {
    flex-direction: column;
  }
`;

// ABOUT THE ROOM COMPONENT //

export const AboutTheRoomSection = styled(RoomDetailsSection)`
  margin: 24px 0;
`;
export const AboutTheRoomRow = styled.div`
  display: flex;
  flex-direction: column;
`;

// AVAILABILITY AND PRICES COMPONENT //

export const AvailabilityAndPricesSection = styled(RoomDetailsSection)`
  margin-top: -16px;
`;

export const AboutTheRoomDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ChatContainer = styled.div<{ $isSmallOnMobile?: boolean }>`
  text-align: center;
  margin: 1rem auto !important;

  ${({ $isSmallOnMobile }) =>
    $isSmallOnMobile &&
    css`
      @media ${({ theme }) => theme.media.phone} {
        .ant-btn {
          font-size: 14px;
          padding-left: 0.5rem;
          padding-right: 0.5rem;
        }
      }
    `}
`;

// RIGHT COLUMN //

export const RightColumnAbout = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 16px;
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    margin: 24px 0;
  }
`;

// HOST DETAILS COMPONENT //

export const HostDetailsWrapper = styled.div`
  min-width: 288px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dcd6ce;
  border-radius: 4px;
  background: #fff;
  padding: 24px;
  margin: 10px;
`;

export const HostInfoWrapper = styled.div`
  display: flex;
  flex-direction: row; /* Keep this to ensure the image is to the left */
`;

export const HostDetailsStyle = styled.div`
  margin-left: 16px; // Adjust as needed
  display: flex;
  flex-direction: column;
`;

export const HostName = styled.div`
  font-size: 24px; // Adjust as needed
  font-weight: bold;
`;

export const AgeGender = styled.div`
  // Add styles for the Age and Gender line
`;

export const HouseholdType = styled.div`
  // Add styles for the household type line
`;

export const Country = styled.div`
  // Add styles for the country line
  color: red; // Adjust as needed
`;

export const Activity = styled.div`
  // Add styles for the years active and times hosted section
`;

export const ImageContainer = styled.div`
  & img {
    height: 90px;
    width: 90px;
    border-radius: 50%;
  }
`;

export const PriceWrapper = styled.div`
  min-width: 288px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dfe1eb;
  border-radius: 4px;
  background: #f2f2f2;
  padding: 24px;
  margin: 10px;
  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    background: transparent;
    flex-direction: column;
  }
`;

export const DateWrapper = styled.div`
  display: flex;
`;

export const CostContainer = styled.div`
  position: absolute;
  top: 100%;
  left: -15em;
  background-color: white;
  border: 1px solid #ccc;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
  width: 305px;
`;

export const CostContainerMobile = styled.div``;

export const CostHoverWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.5rem 0;
  background-color: #f6f8fd;
  padding: 16px;
  border-radius: 4px;
  justify-content: space-between;
  gap: 8px;
  /* align-items: center; */
`;
export const DepositWrapper = styled.div`
  margin-top: 24px; // Added spacing before deposit line

  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  background-color: #f6f8fd;
  padding: 8px 16px;
  border-radius: 4px;
  justify-content: space-between;
  gap: 8px;
`;

export const StyledHR = styled.hr`
  border: 0;
  height: 1px;
  background: #6f7f9e;
  margin: 10px 0; // Adjusted spacing around the horizontal line
`;

export const CostLine = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 4px 0; // This adds some spacing between the lines
  align-items: center; /* Vertically center the children (text and price) */
`;

export const PriceText = styled.span`
  color: #032565;
  font-size: 14px;
  font-weight: 400;
  line-height: 18.2px;
`;

export const PriceValue = styled.span<{ fontSize?: string }>`
  font-size: ${(props) => props.fontSize || "14px"};
  color: #032565;
  text-align: right;
  font-weight: 400;
  line-height: 18.2px;
`;

export const HostDetailsInfoSection = styled.div`
  display: flex;
  justify-content: space-between;

  & img {
    height: 120px;
    width: 120px;
    border-radius: 50%;
  }
`;

export const HostDetailsAbout = styled.div`
  display: flex;
  flex-direction: column;

  & div {
    margin-top: 8px;
  }
`;

// SOCIAL PREFERENCES COMPONENT //

export const SocialPreferensecRange = styled.div`
  margin-top: 24px;
`;

// MAP //

const markerSize = 100;

export const MapWrapper = styled.div`
  min-width: 288px;
  display: flex;
  flex-direction: column;
  border: 1px solid #dcd6ce;
  border-radius: 4px;
  background: #fff;
  padding: 24px;
  margin: 10px;

  @media (max-width: ${maxWidthMediaLeftColumn}px) {
    border: 0;
    margin: 0;
    padding: 0;
  }
`;

export const MapSelectedPlace = styled.div`
  height: ${markerSize - 20}px;
  width: ${markerSize}px;

  position: absolute;
  top: -${markerSize - 20}px;
  left: -${markerSize / 2 - 10}px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: center / contain no-repeat url(${hh}) #eeeeee97;
  border-radius: 20px;
  & div {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    left: 25%;
    top: 50%;
  }
`;

export const MapWithRoomRoot = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 1rem;
  @media (max-width: ${maxWidthMediaRightColumn}px) {
    margin: 0;
  }
`;
export const MapWithRoomImage = styled.img<{ width?: string; height?: string }>`
  max-width: 100%;
  padding: 0 16px;
  cursor: pointer;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "400px"};

  @media (max-width: ${maxWidthMediaRightColumn}px) {
    padding: 0;
  }
`;
export const MapWithRoomImageCaption = styled.div`
  margin-top: 8px;
  cursor: pointer;
`;

export const HostProfileWrapper = styled.div`
  // Your styles here
`;

export const HostInfoSection = styled.div`
  display: flex;
  justify-content: space-between;
  // More styles
`;

export const TitleH2 = styled.h2<{ m?: string }>`
  color: #333333;
  font-size: ${(props) => props.theme.font.sizeSubTitle};
  font-weight: 600;
  margin: ${(props) => props.m || "0"};
`;

export const TitleH3 = styled.h3<{ m?: string; fontSize?: string }>`
  color: #333333;
  font-size: ${(props) => props.fontSize || props.theme.font.size};
  font-weight: 500;
  line-height: 24px;
  margin: ${(props) => props.m || "0px 0px 4px 0px"};
`;

export const TitleH4 = styled.h4<{ m?: string; fontSize?: string }>`
  color: #333333;
  font-size: ${(props) => props.fontSize || props.theme.font.size};

  font-weight: 400;
  line-height: 24px;
  margin: ${(props) => props.m || "0"};
`;

export const StickyFooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  height: 80px;
  display: flex;
  background-color: #ffffff;
  box-shadow: 0px 1px 15px -3px #0000001a;
  width: 100%;
  align-items: center;
  /* margin: 0 8px; */
`;

export const InfoWrapper = styled.div`
  margin-left: 8px;
`;
